import DatePicker from "react-datepicker";
import styles from "./DatePicker.desktop.module.css";
import { useMemo } from "react";
import type DatePickerProperties from "../DatePicker.properties.ts";
import { useDatePickerController } from "../DatePicker.controller.ts";
import { CustomCalendarContainer } from "../shared/CustomCalendarContainer.view.tsx";
import { DateButtonInput } from "../shared/DateButtonInput.view.tsx";
import type CalendarProps from "../Calendar.properties.ts";
import type { CustomCalendarContainerProperties } from "../shared/CustomCalendarContainer.properties.ts";

export default function DatePickerDesktopView(props: DatePickerProperties) {
  const {
    resolveCssColorClassByDates,
    onCalendarButtonClick,
    onCalendarChange,
    setIsOpen,
    nextSixMonthEnds,
    selectedDate,
    isOpen,
    datePickerRef,
  } = useDatePickerController(props);

  const calendarContainer = useMemo(() => {
    return (
      containerProps: CalendarProps & CustomCalendarContainerProperties,
    ) => (
      <CustomCalendarContainer
        {...containerProps}
        showNextThreeMonthButtons={props.showNextThreeMonthButtons}
        nextSixMonthEnds={nextSixMonthEnds}
        onCalendarButtonClick={onCalendarButtonClick}
      />
    );
  }, [
    props.showNextThreeMonthButtons,
    nextSixMonthEnds,
    onCalendarButtonClick,
  ]);

  return (
    <DatePicker
      ref={datePickerRef}
      className={styles.datePicker}
      selected={selectedDate}
      onChange={(date: Date | null) => onCalendarChange(date)}
      placeholderText={props.placeholder}
      dateFormat={props.dateFormat}
      dayClassName={(date) => resolveCssColorClassByDates(date)}
      calendarContainer={calendarContainer}
      customInput={<DateButtonInput />}
      startOpen={props.open}
      open={isOpen}
      onClickOutside={() => setIsOpen(false)}
      onSelect={() => setIsOpen(false)}
      onInputClick={() => setIsOpen(true)}
    />
  );
}
